export enum EModeAffichage {
    Consultation = 'C',
    Ajout = 'A',
    Modification = 'M'
}